import { Entities } from 'client/store/index'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BaseEntityInterface } from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { TFunction } from 'i18next'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { getEntityNameLocoKeyByEntityType } from 'src/shared/utils/get-entity-name-loco-key-by-entity-type'

export const getEntityCustomName = ({
  entityType,
  entities,
  t,
}: {
  entityType: EntityTypeEnum
  entities: Entities
  t: TFunction
}) => {
  const sameTypeEntities = Object.values(entities).filter(
    entity => entity.type === entityType,
  )
  const sameTypeEntitiesAmount = sameTypeEntities.length
  const postfix =
    sameTypeEntitiesAmount > 0 ? ` ${sameTypeEntitiesAmount + 1}` : ''
  // NOTE: Start with a human-friendly name.
  // Example: no forms yet -> "Form"; existing forms: "Form", "Form 2" -> next base name "Form 3".
  const name = `${t(getEntityNameLocoKeyByEntityType(entityType))}${postfix}`

  const solvedName = solveDuplicatedName(name, sameTypeEntities, 0)
  return solvedName
}

const solveDuplicatedName = (
  name: string,
  selectedEntities: (BaseEntityInterface | OldEntityInterface)[],
  count: number,
) => {
  // NOTE: If the base name is already used, append " (1)", " (2)", ... until unique.
  // Example: if "Form 3" already exists -> try "Form 3 (1)", then "Form 3 (2)", etc.
  const postfix = count > 0 ? ` (${count})` : ''
  const solvedName = `${name}${postfix}`
  const duplicatedName = selectedEntities.some(
    entity => (entity as FormInterface).customName === solvedName,
  )
  if (duplicatedName) {
    return solveDuplicatedName(name, selectedEntities, count + 1)
  } else {
    return solvedName
  }
}
